import services from './../../services/service'; // Service Class
import MenuBottom from './../../components/templates/menubottom.vue'; 
let service = new services();

export default {
    name: "MainFooter",
    data() {
        return {
            user: {}, 
            user_slug: {}
        }
    },
    components: {
        'component-menu-bottom': MenuBottom,
    },
 
}


// WEBPACK FOOTER //
// ./src/pages/MainFooter/script.js